import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

// outline doesn't follow border-radius on Safari (version 16.3). Don't use outline.
// It's fixed on latest Safari Preview(version 16.4) however the fix not included on latest stable Safari https://webkit.org/blog/13575/release-notes-for-safari-technology-preview-157/
export const Container = styled("div")`
    width: calc(100vw - 2.75rem);
    display: flex;
    flex-shrink: 0;
    flex-grow: 1;
    color: ${({theme}) => theme.uxfabric.text.primary};
    background: ${({theme}) => theme.uxfabric.action.strong.enabled.backgroundColor};

    @media (min-width: ${breakpoints.values.md}px) {
        width: 100%;
        flex: 0;
        border: 1px solid ${({theme}) => theme.uxfabric.action.strong.enabled.borderColor};
        border-bottom: 1px solid ${({theme}) => theme.uxfabric.action.strong.enabled.borderBottomColor};
        border-radius: ${({theme}) => theme.uxfabric.shape.global.textField.medium.borderRadius};

        &:hover {
            box-shadow: none;
        }

        &:focus-within {
            outline-offset: 0.0625rem;
            outline: 0.125rem solid ${({theme}) => theme.uxfabric.interactive.focus.default.outlineColor};

            &:hover {
                border: 0.0625rem solid ${({theme}) => theme.uxfabric.action.strong.selected.borderColor};
                border-bottom: 1px solid ${({theme}) => theme.uxfabric.action.strong.selected.borderBottomColor};
            }
        }
    }

    &:hover {
        button {
            &:hover,
            &:active {
                background: ${({theme}) => theme.uxfabric.action.strong.selected.backgroundColor};
            }
            background: ${({theme}) => theme.uxfabric.action.strong.hovered.backgroundColor};
        }
        background: ${({theme}) => theme.uxfabric.action.strong.selected.backgroundColor};
        border-color: ${({theme}) => theme.uxfabric.action.strong.selected.borderColor};
        border-bottom: 1px solid ${({theme}) => theme.uxfabric.action.strong.selected.borderBottomColor};
        box-shadow: none;
    }

    &:focus-within {
        button {
            &:hover,
            &:active {
                background: ${({theme}) => theme.uxfabric.action.default.enabled.backgroundColor};
            }
            background: ${({theme}) => theme.uxfabric.action.default.enabled.backgroundColor};
        }
        background: ${({theme}) => theme.uxfabric.action.default.enabled.backgroundColor};
        border: 0.0625rem solid ${({theme}) => theme.uxfabric.action.strong.enabled.borderColor};
        border-bottom: 1px solid ${({theme}) => theme.uxfabric.action.strong.enabled.borderBottomColor};
    }

    @media (max-width: ${breakpoints.values.md - 1}px) {
        &:focus-within {
            border: 0.125rem solid #1d89dd;
        }
    }
`

export const Form = styled("form")`
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;

    div {
        margin: 0;
    }
    border-left: 0;
    margin: 0;
`

export const HiddenLabel = styled("label")`
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
`

export const SearchBoxContainer = styled("div")`
    display: flex;
    flex: 1;
`
